import { Colors } from "swing-components";

import { RadioInput } from "~components";
import type { RadioAnswerType } from "~onboarding/utils";

type RadioAnswerProps = Omit<RadioAnswerType, "type"> & {
  /**
   * The value of the answer. This is undefined when there is no answer.
   */
  value?: string;
  /**
   * When answering the Question, pass the `value` to the parent.
   */
  onChange: (value: string) => void;
  /**
   * Disables the editability of the answer.
   */
  isReadOnly?: boolean;
};

export function RadioAnswer(props: RadioAnswerProps) {
  const { value, onChange, isReadOnly, options } = props;

  return (
    <div>
      {options.map((option, index) => {
        const isLast = index === options.length - 1;

        return (
          <div
            key={option.value}
            css={{
              borderBottom: !isLast ? `1px solid ${Colors.slate200}` : undefined,
              padding: "16px 24px",
            }}
          >
            <RadioInput
              isDisabled={isReadOnly}
              isSelected={value === option.value}
              onChange={onChange}
              label={option.label}
              value={option.value}
            />
            {/* when isCorrect is defined AND this option is selected show correct text */}
            {option.isCorrect === true && value === option.value && (
              <span
                css={{
                  transform: "translate(calc(20px + 16px), 0px)",
                  display: "inline-block",
                  fontSize: 12,
                  color: Colors.green500,
                }}
              >
                Correct!
              </span>
            )}
            {/* when isCorrect is defined AND this option is NOT selected show incorrect text */}
            {option.isCorrect === false && value === option.value && (
              <span
                css={{
                  transform: "translate(calc(20px + 16px), 0px)",
                  display: "inline-block",
                  fontSize: 12,
                  color: Colors.red500,
                }}
              >
                That's not right, try again!
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
}
